import SelectSlot from "public/assets/select-slot.svg";
import ClassMaterial from "public/assets/class-material.svg";
import CameraIcon from "public/assets/foto.svg";
import PenPaper from "public/assets/pen-paper.svg";

interface Information {
  id: number;
  imgSrc: string;
  alt: string;
  heading: string;
  subheading: string;
}

const informationData: Information[] = [
  {
    id: 1,
    imgSrc: SelectSlot,
    alt: "select-slot-img",
    heading: "Pilih slot Kelas Live",
    subheading:
      "Kamu udah terdaftar. Sekarang, tinggal pilih jadwal kelas yang paling sesuai untukmu, deh."
  },
  {
    id: 2,
    imgSrc: ClassMaterial,
    alt: "class-material-img",
    heading: "Gabung Kelas Live",
    subheading:
      "Masuk Kelas Live terus belajar bareng komunitas ambis se-Indonesia."
  },
  {
    id: 3,
    imgSrc: CameraIcon,
    alt: "photo-question-img",
    heading: "Foto soal pakai Tanya",
    subheading: "Foto soal dan belajar caranya pakai video solusi."
  },
  {
    id: 4,
    imgSrc: PenPaper,
    alt: "practice-everyday-img",
    heading: "Latihan tiap hari",
    subheading: "Cuma 15 menit, tapi bisa bikin tambah percaya diri!"
  }
];

export { informationData };
